import React, { Component, Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { connect } from 'react-redux';
import { setUserDetails, logout } from './components/login/action';
import AuthService from './components/Services/AuthService';
import './app.scss';
import { ROLE_ADMIN, ROLE_ANALYST, ROLE_CORPORATE, ROLE_CORRESPONDENT } from './constants';
import { getUserInfo, loggedIn, setToken } from './helper';
import {logout as logoutUser}  from './helper';
import ReactGA from 'react-ga';
import { REACT_APP_GOOGLE_ANALYST_CODE ,CUSTOMER_UI} from '../src/config';
import Admin from './Admin/admin';
import Corporate from './Corporate/corporate';
import Analyst from './Analyst/analyst';
import AllUserListComponent from './Admin/user-management/all-users';
import Correspondent from './Correspondent/correspondent/index';
import TheodoreLogin from './components/Theodore/login';
import TheodoreForgotPassword from './components/Theodore/forgot-password';
import ChangePassword from './components/change-password';
import withRouter from './withRouter';
import { jwtDecode } from "jwt-decode";

const AdminWithRouter = withRouter(Admin);
const CorporateWithRouter = withRouter(Corporate);
const AnalystWithRouter = withRouter(Analyst);
const AllUserListComponentwithRouter =withRouter(AllUserListComponent);
const CorrespondentWithRouter = withRouter(Correspondent);
const ChangePasswordWithRouter = withRouter(ChangePassword);


class App extends Component {
    constructor() {
        super();
        this.enviornment = process.env.NODE_ENV;
        this.state = {
            welcome: 'Welcome to Rubix',
            isCorporate: false,
            loggedIn: false
        }
        this.Auth = new AuthService();
    }

    componentDidMount() {
        ReactGA.initialize(REACT_APP_GOOGLE_ANALYST_CODE, { debug: false, allowAnchor: true });
        if (!this.props.loginSuccess.hasOwnProperty('token') && loggedIn()) {
            this.props.setUserDetails(getUserInfo());
        }

        if (window.opener) {
            window.opener.postMessage("READY_FOR_TOKEN", CUSTOMER_UI);
        }

        // Listen for token from parent
        window.addEventListener("message", (event) => {
            console.log("received token")

            if (event.origin === CUSTOMER_UI && event.data?.type === "AUTH_TOKEN") {
                const { loginSuccess } = event.data || {};
                console.log("received loginDetails", loginSuccess)

                setToken(loginSuccess);
                this.props.setUserDetails(getUserInfo());
                
            }
        });

    }

    render() {
        const { userDetails } = this.props;
        const loginComp = <TheodoreLogin {...this.state} />;
        if (Object.keys(userDetails).length > 0) {
            const scope = userDetails.scopes[0];
            switch (scope) {
                case ROLE_ADMIN:
                    return (
                        <BrowserRouter>
                            <Routes>
                                <Route path='/login' element={<Navigate to='/' />} />
                                <Route path='/*' element={<AdminWithRouter {...this.props} />} />
                            </Routes>
                        </BrowserRouter>
                    );
                case ROLE_CORPORATE:
                    return (
                        <BrowserRouter>
                            <Routes>
                                <Route path='/login' element={<Navigate to='/' />} />
                                <Route path='/*' element={<CorporateWithRouter {...this.props} />} />
                            </Routes>
                        </BrowserRouter>
                    );
                case ROLE_ANALYST:
                    return (
                        <BrowserRouter>
                            <Routes>
                                <Route path='/login' element={<Navigate to='/' />} />
                                <Route path='/*' element={<AnalystWithRouter {...this.props} />} />
                            </Routes>
                        </BrowserRouter>
                    );
                case ROLE_CORRESPONDENT:
                    return (
                        <BrowserRouter>
                            <Routes>
                                <Route path='/login' element={<Navigate to='/' />} />
                                <Route path='/*' element={<CorrespondentWithRouter {...this.props} />} />
                            </Routes>
                        </BrowserRouter>
                    );
                default:
                    return (
                        <BrowserRouter>
                            <Routes>
                                <Route path="/login" element={loginComp} />
                                <Route path="/forgot" element={<TheodoreForgotPassword />} />
                                <Route path='/change/password/:token' element={<ChangePasswordWithRouter {...this.props}/>} />
                                <Route path="/*" element={loginComp} />
                            </Routes>
                        </BrowserRouter>
                    );
            }
        } else {
            return (
                <BrowserRouter>
                    <Routes>
                        <Route path="/login" element={loginComp} />
                        <Route path="/forgot" element={<TheodoreForgotPassword />} />
                        <Route path='/change/password/:token' element={<ChangePasswordWithRouter {...this.props}/>} />
                        <Route path="/*" element={loginComp} />
                    </Routes>
                </BrowserRouter>
            );
        }
    }
}

const mapStateToProps = (state) => ({
    loginSuccess: state.loginDetails.loginSuccess,
    loginFailure: state.loginDetails.loginFailure,
    userDetails: state.loginDetails.userDetails
});

const mapDispatchToProps = (dispatch) => ({
    setUserDetails: (data) => { dispatch(setUserDetails(data)) },
    logout: () => { dispatch(logout()) }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);
